module.exports = __webpack_public_path__ + "img/Bastion-37.08a1ec2f.png";